export const config = {
  school: {
    name: "Southern University",
    emailFormat: /[\d\w]+@southern.edu$/,
    email: "@southern.edu",
  },
};
